export const DEMO_PARTICIPANT_LIMIT_CODE = "demo_participant_limit_reached";

export type ParticipantJoinError = Error & {
  code?: string;
};

/**
 * Join routes are deliberately public, so they do not use the authenticated
 * apiFetch helper. Keep the small amount of error decoding shared so a demo
 * capacity response can be presented distinctly without changing ordinary
 * classroom join errors.
 */
export async function participantJoinError(response: Response, fallback: string): Promise<ParticipantJoinError> {
  const text = await response.text().catch(() => "");
  let detail: unknown = text;
  try {
    const body = text ? JSON.parse(text) : null;
    detail = body?.detail ?? body?.message ?? text;
  } catch {
    // Non-JSON errors remain ordinary join errors.
  }

  const code = detail && typeof detail === "object" ? (detail as { code?: unknown }).code : undefined;
  const message =
    typeof detail === "string"
      ? detail
      : detail && typeof detail === "object" && typeof (detail as { message?: unknown }).message === "string"
        ? (detail as { message: string }).message
        : fallback;
  const error = new Error(message) as ParticipantJoinError;
  if (typeof code === "string") error.code = code;
  return error;
}

export function isDemoParticipantLimitError(error: unknown): error is ParticipantJoinError {
  return Boolean(error && typeof error === "object" && (error as ParticipantJoinError).code === DEMO_PARTICIPANT_LIMIT_CODE);
}
